import {
    WeChatChatroom,
    WeChatChatroomInfo,
    WeChatMsg,
    WeChatPagination,
    WeChatSession,
    WeChatContact,
    WeChatSearchConv,
} from "@/store/modules/weChat/types";
import axios from '@/requests';

export interface GetWechatIdParam {
    projid: string,
    uid: string,
}

export interface GetWeChatSessionParam extends WeChatPagination {
    projId: string
    uid: string
    wechatId: string
}

export interface GetWeChatMsgListParam extends WeChatPagination {
    projid: string,
    uid: string,
    wechatId: string,
    name: string,
}

export interface GetWeChatChatroomParam {
    uid: string,
    name: string,
}

export interface FuzzySearchParams extends GetWeChatSessionParam {
    target: string,
}
export interface GetMsgOfFuzzySearchParams extends FuzzySearchParams {
    name: string,
}

export interface GetParticipantsParam extends GetWeChatSessionParam {
    chatroomName: string,
}
const extractStringFromBase64 = (base64Data: string) => {
    const binaryData = atob(base64Data);

    const endIndex = binaryData.indexOf(String.fromCharCode(0x1a), 12);
    if (endIndex === -1) {
        return '';
    }

    return binaryData.substring(12, endIndex);
}

export const weChatAPI = {
    async getSessionListByUid(reqParam: GetWeChatSessionParam): Promise<WeChatSession[]> {
        try {
            const res = await axios.get<WeChatSession[]>("/WeChat/getSessionListByUid", reqParam);

            if (res) {
                return res;
            } else {
                return [];
            }
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getContactListByUid(reqParam: GetWeChatSessionParam): Promise<WeChatContact[]> {
        try {
            const res = await axios.get<WeChatContact[]>("/WeChat/getContactListByUid", reqParam);
            return res
            // if (res) {
            //     return res;
            // } else {
            //     return [];
            // }
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getChatrooomListByUid(reqParam: GetWeChatSessionParam): Promise<WeChatContact[]> {
        try {
            const res = await axios.get<WeChatContact[]>("/WeChat/getChatroomListByUid", reqParam);
            return res
            // if (res) {
            //     return res;
            // } else {
            //     return [];
            // }
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getParticipantsByChatroomName(reqParam: GetParticipantsParam): Promise<WeChatContact[]> {
        try {
            return await axios.get<WeChatContact[]>("/WeChat/getParticipantListByChatroomName", reqParam);
            // if (res) {
            //     return res;
            // } else {
            //     return [];
            // }
        } catch (err) {
            return Promise.reject(err);
        }
    },

    async asyncGetMsgListByUidAndName(reqParam: GetWeChatMsgListParam): Promise<WeChatMsg[]> {
        try {
            const res = await axios.get<WeChatMsg[]>("/WeChat/getMsgListByUidAndName", reqParam);

            // if (res) {
            //     return res.map((msg: WeChatMsg) => {
            //         if (msg.IsSender === 1) {
            //             msg.senderStrEx = "我";
            //         } else {
            //             msg.senderStr = extractStringFromBase64(msg.BytesExtra);
            //         }
            //         return msg;
            //     });
            // } else {
            //     return [];
            // }
            return res

        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncGetChatroomByUidAndName(reqParam: GetWeChatChatroomParam): Promise<WeChatChatroom> {
        try {
            return await axios.get<WeChatChatroom>("/WeChat/getChatroomByUidAndName", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncGetChatroomInfoByUidAndName(reqParam: GetWeChatChatroomParam): Promise<WeChatChatroomInfo> {
        try {
            return await axios.get<WeChatChatroomInfo>("/WeChat/getChatroomInfoByUidAndName", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncGetWechatIdByProjIdAndUid(reqParam: GetWechatIdParam): Promise<WeChatContact[]> {
        try {
            return await axios.get<WeChatContact[]>("/WeChat/getWechatIdByProjIdAndUid", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncFuzzySearchWeChatContact(reqParam: FuzzySearchParams): Promise<WeChatSession[]> {
        try {
            return await axios.get<WeChatSession[]>("/WeChat/fuzzySearchWeChatContact", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncFuzzySearchWeChatConv(reqParam: FuzzySearchParams): Promise<WeChatSearchConv[]> {
        try {
            return await axios.get<WeChatSearchConv[]>("/WeChat/fuzzySearchWeChatConv", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncGetMsgListForSearchResultOfWechatConv(reqParam: GetMsgOfFuzzySearchParams): Promise<WeChatMsg[]> {
        try {
            return await axios.get<WeChatMsg[]>("/WeChat/getMsgListForSearchResultOfWechatConv", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncFuzzySearchWeChatChat(reqParam: FuzzySearchParams): Promise<WeChatSearchConv[]> {
        try {
            return await axios.get<WeChatSearchConv[]>("/WeChat/fuzzySearchWeChatChat", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async asyncGetMsgListForSearchResultOfWechatChat(reqParam: GetMsgOfFuzzySearchParams): Promise<WeChatMsg[]> {
        try {
            return await axios.get<WeChatMsg[]>("/WeChat/getMsgListForSearchResultOfWechatChat", reqParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },


}